import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Select from 'react-select';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    ButtonGroup,
    Form,
    FormGroup,
    Input,
    Label,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import Header from 'components/Headers/Header';
import { useParams } from 'react-router-dom';
import { FaDownload, FaPencilAlt, FaTrash, FaPlus } from 'react-icons/fa';
import { apiURL1 } from '../../config';
import Footer from 'components/Footers/Footer';

const AddTeacher = () => {
    const token = localStorage.getItem("token");

    const { id } = useParams();
    const [activeTab, setActiveTab] = useState('profile');
    const [formData, setFormData] = useState({
        name: '',
        gender: '',
        dob: '',
        nationality: '',
        pic: null,
        city: '',
        state: '',
        country: '',
        emergencyContactName: '',
        emergencyContactRelation: '',
        emergencyContactPhone: '',
        joinDate: '',
        initialExperience: 0,
        expertise: '',
        teacherID: '',
        language: [],
        Notes: '',
        degree: null,
        certificate: null,
        email: '',
        type: '',
        salary: 0,
        status: 'ACTIVE',
        terminationDate: '',
    });
    const [picPreview, setPicPreview] = useState(null);
    const [teacherNotFound, setTeacherNotFound] = useState(false);

    const languageOptions = [
        { value: 'english', label: 'English' },
        { value: 'sinhala', label: 'Sinhala' },
        { value: 'tamil', label: 'Tamil' },
        { value: 'arabic', label: 'Arabic' },
        { value: 'hindi', label: 'Hindi' },
        { value: 'malayalam', label: 'Malayalam' },
        { value: 'telugu', label: 'Telugu' },
    ];

    useEffect(() => {
        if (id) {
            const fetchTeacherData = async () => {
                try {
                    const response = await axios.get(
                        `${apiURL1}/superadmin/getTeacherById/${id}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            }
                        }
                    );
                    const teacherData = response.data.teacher;

                    if (teacherData) {
                        setFormData({
                            name: teacherData.name || '',
                            gender: teacherData.gender || '',
                            dob: teacherData.dob ? teacherData.dob.split('T')[0] : '',
                            nationality: teacherData.nationality || '',
                            pic: teacherData.pic || null,
                            city: teacherData.city || '',
                            state: teacherData.state || '',
                            country: teacherData.country || '',
                            emergencyContactName: teacherData.emergencyContactName || '',
                            emergencyContactRelation: teacherData.emergencyContactRelation || '',
                            emergencyContactPhone: teacherData.emergencyContactPhone || '',
                            joinDate: teacherData.joinDate ? teacherData.joinDate.split('T')[0] : '',
                            initialExperience: teacherData.initialExperience || 0,
                            expertise: teacherData.expertise || '',
                            teacherID: teacherData.teacherID || '',
                            language: teacherData.language || [],
                            Notes: teacherData.Notes || '',
                            degree: teacherData.degree || null,
                            certificate: teacherData.certificate || null,
                            email: teacherData.email || '',
                            type: teacherData.type || '',
                            salary: teacherData.salary || 0,
                            status: teacherData.status || 'ACTIVE',
                            terminationDate: teacherData.terminationDate ? teacherData.terminationDate.split('T')[0] : '',
                        });
                        if (teacherData.pic) {
                            setPicPreview(teacherData.pic);
                        }
                        setTeacherNotFound(false);
                    } else {
                        toast.warn('staff not found.');
                        setTeacherNotFound(true);
                    }
                } catch (error) {
                    console.error('Error fetching teacher data:', error);
                    toast.error('Error fetching staff data!');
                    setTeacherNotFound(true);
                }
            };

            fetchTeacherData();
        }
    }, [id, token]);

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;

        setFormData((prevData) => {
            if (type === 'file') {
                if (name === 'pic') {
                    setPicPreview(URL.createObjectURL(files[0]));
                }
                return { ...prevData, [name]: files[0] };
            }
            return { ...prevData, [name]: value };
        });
    };

    const handleLanguageChange = (selectedOptions) => {
        setFormData((prevData) => ({
            ...prevData,
            language: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };

    const handleGenerateTeacherID = () => {
        const newTeacherID = uuidv4();
        setFormData((prevData) => ({ ...prevData, teacherID: newTeacherID }));
    };

    const handleSave = async () => {
        try {
            const form = new FormData();
            if (id) {
                form.append('userId', id);
            }

            for (const key in formData) {
                if (formData[key] !== null) {
                    form.append(key, formData[key]);
                }
            }

            const url = `${apiURL1}/superadmin/teachers`;
            await axios({
                method: 'put',
                url,
                data: form,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                },
            });
            toast.success(`Staff ${id ? 'updated' : 'created'} successfully!`);
        } catch (error) {
            toast.error(`Error ${id ? 'updating' : 'creating'} staff!`);
            console.error(`Error ${id ? 'updating' : 'creating'} teacher:`, error);
        }
    };

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    if (teacherNotFound) {
        return (
            <Container className="mt-1" fluid>
                <Header />
                <Row className="mt-10">
                    <Col className="order-xl-1" xl="12">
                        <Card className="bg-secondary shadow">
                            <CardBody>
                                <h2>Staff not found</h2>
                                <p>The staff with ID {id} could not be found.</p>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container className="mt-1" fluid>
            <Header />
            <Row className="mt-10">
                <Col className="order-xl-1" xl="12">
                    <Card className="bg-secondary shadow">
                        <CardHeader className="bg-white border-0">
                            <Row className="align-items-center">
                                <Col xs="8">
                                    <h3 className="mb-0">
                                        {id ? 'Edit Staff' : 'Create Staff'}
                                    </h3>
                                </Col>
                                <Col className="text-right" xs="4">
                                    <Button color="primary" onClick={handleSave} size="sm">
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="d-flex align-items-center mb-3" style={{ gap: '8px' }}>
                                <Button
                                    size="sm"
                                    color={activeTab === "profile" ? "info" : "secondary"}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleTab("profile");
                                    }}
                                >
                                    Profile
                                </Button>
                                <Button
                                    size="sm"
                                    color={activeTab === "allowances" ? "info" : "secondary"}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleTab("allowances");
                                    }}
                                >
                                    Allowances
                                </Button>
                            </div>

                            {activeTab === 'profile' && (
                                <ProfileTab
                                    formData={formData}
                                    handleInputChange={handleInputChange}
                                    handleLanguageChange={handleLanguageChange}
                                    handleGenerateTeacherID={handleGenerateTeacherID}
                                    picPreview={picPreview}
                                    languageOptions={languageOptions}
                                />
                            )}
                            {activeTab === 'allowances' && (
                                <AllowancesTab teacherId={id} token={token} />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Footer />
        </Container>
    );
};

const ProfileTab = ({
    formData,
    handleInputChange,
    handleLanguageChange,
    handleGenerateTeacherID,
    picPreview,
    languageOptions,
}) => (
    <Form>
        <h6 className="heading-small text-muted mb-4">
            Account Information
        </h6>
        <Row>
            <Col lg="6">
                <FormGroup>
                    <Label
                        className="form-control-label"
                        htmlFor="input-email"
                    >
                        Email
                    </Label>
                    <Input
                        className="form-control-alternative"
                        id="input-email"
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={formData.email}
                        onChange={handleInputChange}
                    />
                </FormGroup>
            </Col>
            <Col lg="6"></Col>
        </Row>
        <Row>
            <Col lg="6">
                <FormGroup>
                    <Label
                        className="form-control-label"
                        htmlFor="input-type"
                    >
                        Type
                    </Label>
                    <Input
                        className="form-control-alternative"
                        id="input-type"
                        type="select"
                        name="type"
                        value={formData.type}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Type</option>
                        <option value="part-time">Part-time</option>
                        <option value="full-time">Full-time</option>
                        <option value="visit">Visit</option>
                    </Input>
                </FormGroup>
            </Col>
            <Col lg="6">
                <FormGroup>
                    <Label
                        className="form-control-label"
                        htmlFor="input-status"
                    >
                        Status
                    </Label>
                    <Input
                        className="form-control-alternative"
                        id="input-status"
                        type="select"
                        name="status"
                        value={formData.status}
                        onChange={handleInputChange}
                    >
                        <option value="ACTIVE">Active</option>
                        <option value="INACTIVE">Inactive</option>
                        <option value="RESIGNED">Resigned</option>
                        <option value="RETIRED">Retired</option>
                        <option value="TERMINATED">Terminated</option>
                    </Input>
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col lg="6">
                <FormGroup>
                    <Label
                        className="form-control-label"
                        htmlFor="input-salary"
                    >
                        Salary
                    </Label>
                    <Input
                        className="form-control-alternative"
                        id="input-salary"
                        type="number"
                        name="salary"
                        placeholder="Enter salary"
                        value={formData.salary}
                        onChange={handleInputChange}
                    />
                </FormGroup>
            </Col>
            {formData.status === 'TERMINATED' && (
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-terminationDate"
                        >
                            Termination Date
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-terminationDate"
                            type="date"
                            name="terminationDate"
                            value={formData.terminationDate}
                            onChange={handleInputChange}
                            required={formData.status === 'TERMINATED'}
                        />
                    </FormGroup>
                </Col>
            )}
        </Row>
        <hr className="my-4" />

        <h6 className="heading-small text-muted mb-4">
            Staff Information
        </h6>
        <div className="pl-lg-4">
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-name"
                        >
                            Name
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-name"
                            type="text"
                            name="name"
                            placeholder="Enter name"
                            value={formData.name}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-gender"
                        >
                            Gender
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-gender"
                            type="select"
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                        >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-dob"
                        >
                            Date of Birth
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-dob"
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-nationality"
                        >
                            Nationality
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-nationality"
                            type="text"
                            name="nationality"
                            placeholder="Enter nationality"
                            value={formData.nationality}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-pic"
                        >
                            Profile Picture
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-pic"
                            type="file"
                            name="pic"
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                    {picPreview && (
                        <img
                            src={picPreview}
                            alt="Profile Preview"
                            style={{
                                maxWidth: '100px',
                                marginTop: '10px',
                                display: 'block',
                            }}
                        />
                    )}
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-city"
                        >
                            City
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-city"
                            type="text"
                            name="city"
                            placeholder="Enter city"
                            value={formData.city}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-state"
                        >
                            State
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-state"
                            type="text"
                            name="state"
                            placeholder="Enter state"
                            value={formData.state}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-country"
                        >
                            Country
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-country"
                            type="text"
                            name="country"
                            placeholder="Enter country"
                            value={formData.country}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <hr className="my-4" />
            <h6 className="heading-small text-muted mb-4">
                Emergency Contact Information
            </h6>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-emergencyContactName"
                        >
                            Emergency Contact Name
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-emergencyContactName"
                            type="text"
                            name="emergencyContactName"
                            placeholder="Enter emergency contact name"
                            value={formData.emergencyContactName}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-emergencyContactRelation"
                        >
                            Emergency Contact Relation
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-emergencyContactRelation"
                            type="text"
                            name="emergencyContactRelation"
                            placeholder="Enter emergency contact relation"
                            value={formData.emergencyContactRelation}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-emergencyContactPhone"
                        >
                            Emergency Contact Phone
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-emergencyContactPhone"
                            type="text"
                            name="emergencyContactPhone"
                            placeholder="Enter emergency contact phone"
                            value={formData.emergencyContactPhone}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <hr className="my-4" />
            <h6 className="heading-small text-muted mb-4">
                Employment Information
            </h6>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-joinDate"
                        >
                            Join Date
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-joinDate"
                            type="date"
                            name="joinDate"
                            value={formData.joinDate}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-initialExperience"
                        >
                            Initial Experience (Years)
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-initialExperience"
                            type="number"
                            name="initialExperience"
                            placeholder="Enter initial experience"
                            value={formData.initialExperience}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-expertise"
                        >
                            Expertise
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-expertise"
                            type="text"
                            name="expertise"
                            placeholder="Enter expertise"
                            value={formData.expertise}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-teacherID"
                        >
                            Staff ID
                        </Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Input
                                className="form-control-alternative"
                                id="input-teacherID"
                                type="text"
                                name="teacherID"
                                placeholder="Enter staff ID"
                                value={formData.teacherID}
                                onChange={handleInputChange}
                            />
                            <Button
                                color="primary"
                                type="button"
                                onClick={handleGenerateTeacherID}
                                size="sm"
                                style={{ marginLeft: '10px' }}
                            >
                                Auto Generate
                            </Button>
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-language"
                        >
                            Languages
                        </Label>
                        <Select
                            isMulti
                            name="language"
                            options={languageOptions}
                            className="form-control-alternative"
                            value={languageOptions.filter((option) =>
                                formData.language.includes(option.value),
                            )}
                            onChange={handleLanguageChange}
                        />
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-notes"
                        >
                            Notes
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-notes"
                            type="textarea"
                            name="Notes"
                            placeholder="Enter notes"
                            value={formData.Notes}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-degree"
                        >
                            Degree
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-degree"
                            type="file"
                            name="degree"
                            onChange={handleInputChange}
                        />
                        {formData.degree && typeof formData.degree === 'string' && (
                            <a
                                href={formData.degree}
                                target="_blank"
                                rel="noopener noreferrer"
                                download="degree.zip"

                            >
                                Download Degree <FaDownload />
                            </a>
                        )}
                    </FormGroup>
                </Col>
                <Col lg="6">
                    <FormGroup>
                        <Label
                            className="form-control-label"
                            htmlFor="input-certificate"
                        >
                            Certificate
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="input-certificate"
                            type="file"
                            name="certificate"
                            onChange={handleInputChange}
                        />
                        {formData.certificate && typeof formData.certificate === 'string' && (
                            <a
                                href={formData.certificate}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Download Certificate <FaDownload />
                            </a>
                        )}
                    </FormGroup>
                </Col>
            </Row>
            <hr className="my-4" />
        </div>
    </Form>

);

const AllowancesTab = ({ teacherId, token }) => {
    const [allowances, setAllowances] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedAllowance, setSelectedAllowance] = useState(null);
    const [newAllowance, setNewAllowance] = useState({
        name: '',
        type: 'allowance',
        value: 0,
    });
    const [editAllowance, setEditAllowance] = useState({
        name: '',
        type: 'allowance',
        value: 0,
    });

    const allowanceTypes = [
        { value: 'allowance', label: 'Allowance' },
        { value: 'deduction', label: 'Deduction' },
        { value: 'bonus', label: 'Bonus' },
    ];

    useEffect(() => {
        if (teacherId) {
            fetchAllowances();
        }
    }, [teacherId, token]);

    const fetchAllowances = async () => {
        try {
            const response = await axios.get(
                `${apiURL1}/superadmin/getTeacherAllowances/${teacherId}?page=1`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setAllowances(response.data.salaryComponents || []);
        } catch (error) {
            console.error('Error fetching allowances:', error);
            toast.error('Error fetching allowances!');
        }
    };

    const handleAddAllowance = async () => {
        try {
            await axios.post(
                `${apiURL1}/superadmin/addTeacherAllowances/${teacherId}`,
                newAllowance,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            toast.success('Allowance added successfully!');
            fetchAllowances();
            setModalOpen(false);
            setNewAllowance({ name: '', type: 'allowance', value: 0 });
        } catch (error) {
            console.error('Error adding allowance:', error);
            toast.error('Error adding allowance!');
        }
    };

    const handleEditAllowance = (allowance) => {
        setSelectedAllowance(allowance);
        setEditAllowance({ ...allowance });
        setEditModalOpen(true);
    };

    const handleUpdateAllowance = async () => {
        try {
            await axios.put(
                `${apiURL1}/superadmin/updateTeacherAllowance/${teacherId}/allowance/${selectedAllowance._id}`,
                editAllowance,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            toast.success('Allowance updated successfully!');
            fetchAllowances();
            setEditModalOpen(false);
            setSelectedAllowance(null);
            setEditAllowance({ name: '', type: 'allowance', value: 0 });
        } catch (error) {
            console.error('Error updating allowance:', error);
            toast.error('Error updating allowance!');
        }
    };

    const handleDeleteAllowance = (allowance) => {
        setSelectedAllowance(allowance);
        setDeleteModalOpen(true);
    };

    const confirmDeleteAllowance = async () => {
        try {
            await axios.delete(
                `${apiURL1}/superadmin/deleteTeacherAllowance/${teacherId}/allowance/${selectedAllowance._id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            toast.success('Allowance deleted successfully!');
            fetchAllowances();
            setDeleteModalOpen(false);
            setSelectedAllowance(null);
        } catch (error) {
            console.error('Error deleting allowance:', error);
            toast.error('Error deleting allowance!');
        }
    };

    const filteredAllowances = allowances.filter((allowance) =>
        allowance.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <Row>
                <Col>
                    <Input
                        type="text"
                        placeholder="Search allowances..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ marginBottom: '10px' }}
                    />
                </Col>
                <Col className="text-right">
                    <Button color="primary" size="sm" onClick={() => setModalOpen(true)}>
                        <FaPlus /> Add New
                    </Button>
                </Col>
            </Row>
            <Table responsive>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Value</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredAllowances.length > 0 ? (
                        filteredAllowances.map((allowance) => (
                            <tr key={allowance._id}>
                                <td>{allowance.name}</td>
                                <td>{allowance.type}</td>
                                <td>{allowance.value}</td>
                                <td>
                                    <ButtonGroup size="sm">
                                        <Button
                                            color="info"
                                            size="sm"
                                            onClick={() => handleEditAllowance(allowance)}
                                        >
                                            <FaPencilAlt />
                                        </Button>
                                        <Button
                                            color="danger"
                                            size="sm"
                                            onClick={() => handleDeleteAllowance(allowance)}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </ButtonGroup>
                                </td>
                            </tr>
                        ))
                    ) :
                        <tr>
                            <td colSpan="4" style={{ textAlign: "center", padding: "10px", fontWeight: "bold" }}>
                                No Allowances Found
                            </td>
                        </tr>
                    }

                </tbody>
            </Table>

            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Add New Allowance</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="allowanceName">Name</Label>
                            <Input
                                type="text"
                                id="allowanceName"
                                placeholder="Enter allowance name"
                                value={newAllowance.name}
                                onChange={(e) => setNewAllowance({ ...newAllowance, name: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="allowanceType">Type</Label>
                            <Input
                                type="select"
                                id="allowanceType"
                                value={newAllowance.type}
                                onChange={(e) => setNewAllowance({ ...newAllowance, type: e.target.value })}
                            >
                                {allowanceTypes.map((type) => (
                                    <option key={type.value} value={type.value}>{type.label}</option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="allowanceValue">Value</Label>
                            <Input
                                type="number"
                                id="allowanceValue"
                                placeholder="Enter allowance value"
                                value={newAllowance.value}
                                onChange={(e) => setNewAllowance({ ...newAllowance, value: parseFloat(e.target.value) })}
                            />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddAllowance}>
                        Add
                    </Button>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>Edit Allowance</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="editAllowanceName">Name</Label>
                            <Input
                                type="text"
                                id="editAllowanceName"
                                placeholder="Enter allowance name"
                                value={editAllowance.name}
                                onChange={(e) => setEditAllowance({ ...editAllowance, name: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="editAllowanceType">Type</Label>
                            <Input
                                type="select"
                                id="editAllowanceType"
                                value={editAllowance.type}
                                onChange={(e) => setEditAllowance({ ...editAllowance, type: e.target.value })}
                            >
                                {allowanceTypes.map((type) => (
                                    <option key={type.value} value={type.value}>{type.label}</option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="editAllowanceValue">Value</Label>
                            <Input
                                type="number"
                                id="editAllowanceValue"
                                placeholder="Enter allowance value"
                                value={editAllowance.value}
                                onChange={(e) => setEditAllowance({ ...editAllowance, value: parseFloat(e.target.value) })}
                            />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleUpdateAllowance}>
                        Update
                    </Button>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
                <ModalHeader toggle={() => setDeleteModalOpen(false)}>Delete Allowance</ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this allowance?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteAllowance}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    );
};

export default AddTeacher;
